var _rect, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404WithShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 289,
    viewBox: "0 0 486 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 178.812,
    y: 154.577,
    width: 162.962,
    height: 170.746,
    transform: "rotate(-38.5107 178.812 154.577)",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 102.5,
    r: 81.5,
    fill: "url(#paint1_radial)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 153.389V118.964L65.0901 25.8889H110.674V117.264H127V153.389H110.674V178.889H68.6945V153.389H0ZM71.8748 72.8514L42.616 117.264H71.8748V72.8514Z",
    fill: "#28293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359 153.389V118.964L424.09 25.8889H469.674V117.264H486V153.389H469.674V178.889H427.694V153.389H359ZM430.875 72.8514L401.616 117.264H430.875V72.8514Z",
    fill: "#28293D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 139,
    y: 0,
    width: 213,
    height: 213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 260.293,
    y1: 154.577,
    x2: 260.293,
    y2: 325.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC2D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.746 72.2995) rotate(58.4124) scale(78.1915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#54556A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28293D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404WithShadow);
export default __webpack_public_path__ + "static/media/404_with_shadow.191ce0074a198f50969ae268bdfe904f.svg";
export { ForwardRef as ReactComponent };